import { useTranslation } from "react-i18next";
import { TitleContainer, TitleStyled } from "./styles";

function HomepageHeader() {
  const { t } = useTranslation();
  const title = t("homepage.header_title");

  // Parse the title to handle <em> tags
  const parts = title.split(/(<em>.*?<\/em>)/g);

  return (
    <TitleContainer>
      <TitleStyled>
        {parts.map((part, index) => {
          if (part.startsWith("<em>") && part.endsWith("</em>")) {
            const text = part.replace(/<\/?em>/g, "");
            return (
              <span key={index} style={{ fontStyle: "italic" }}>
                {text}
              </span>
            );
          }
          return <span key={index}>{part}</span>;
        })}
      </TitleStyled>
    </TitleContainer>
  );
}
export default HomepageHeader;
